export const filterSalesApp = (app) => {
    return app.recommendations ? app.recommendations.some(({ type }) => type === 'SALES') : false;
};
